import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { SidenavItem } from "./sidenav-item/sidenav-item.interface";
import { SidenavService } from "./sidenav.service";
import { ThemeService } from "../../../@prep/services/theme.service";

import { GlobalUser } from "../model/global-user";
import { Subscription } from "rxjs";
import { PlatformGlobalService } from "../service/platform-global.service";
import { CurrentUserService } from "../../pages/authentication/service/current-user.service";
import { DashboardService } from "src/app/pages/dashboard/service/dashboard.service";

import { MatSnackBar } from "@angular/material/snack-bar";

import { LanguageSelectorModel } from "src/@prep/shared/language-selector/model/language-selector.model";
import { LanguageSelectorService } from "src/@prep/shared/language-selector/service/language-selector.service";
import { SideNavTextDataEN } from "./sidenav-multi-lang/en-US";
import { SideNavTextDataES } from "./sidenav-multi-lang/es-EU";
import { SideNavTextDataIT } from "./sidenav-multi-lang/it-IT";

@Component({
  selector: "prep-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  providers: [CurrentUserService],
})
export class SidenavComponent implements OnInit, OnDestroy {
  account: GlobalUser = new GlobalUser();
  userSub: Subscription;
  account_group = [];
  account_user_name: string;
  account_user_email: string;
  isContinualEngine: boolean = false;

  public Current_User: GlobalUser;

  accountOrg: string;

  sidenavUserVisible$ = this.themeService.config$.pipe(
    map((config) => config.sidenavUserVisible)
  );

  @Input()
  @HostBinding("class.collapsed")
  collapsed: boolean;

  @Input()
  @HostBinding("class.expanded")
  expanded: boolean;

  items$: Observable<SidenavItem[]>;


  isWatching?: boolean;
  isTimer?: boolean;
  timeIsUp?: boolean;
  timerCount?: number;



  idleState: string = "Not started.";
  timedOut: boolean = false;
  lastPing?: Date = null;

  private timeoutWarningSubscription: Subscription;
  private idleEndSubscription: Subscription;
  private timeoutSubscription: Subscription;
  private idleStartSubscription: Subscription;
  private keepalivePingSubscription: Subscription;

  idleNum: number = 5; // Idle time in seconds
  timeout: number = 10; // Timeout after idle in seconds
  ping: number = 15; // Keepalive ping interval in seconds

  selectedLang: LanguageSelectorModel =
    this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;

  expandedSidenav: boolean = false;
  constructor(
    private router: Router,
    private platformglobalService: PlatformGlobalService,
    private sidenavService: SidenavService,
    private currentUserService: CurrentUserService,
    private themeService: ThemeService,
    private dashboardService: DashboardService,
    private snackbar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private languageSelectorService: LanguageSelectorService
  ) {
    this.languageSelectorService.language$.subscribe((lang) => {
      this.selectedLang = lang;
      console.log(
        "🌍 Language changed:",
        lang,
        lang.code,
        this.selectedLang.code
      );
      switch (this.selectedLang.code) {
        case "en": {
          this.LangTextData = SideNavTextDataEN;
          console.log("🌍 English Language:", this.LangTextData);
          break;
        }
        case "es": {
          this.LangTextData = SideNavTextDataEN;
          console.log("🌍 English Language:", this.LangTextData);
          break;
        }
        case "it": {
          this.LangTextData = SideNavTextDataEN;
          console.log("🌍 English Language:", this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = SideNavTextDataEN;
          console.log("🌍 Default Language:", this.LangTextData);
          break;
        }
      }
    });
  }

  announceMessage(message: string) {
    const region = document.getElementById("a11y-live-region");
    if (region) {
      region.textContent = "";
      setTimeout(() => (region.textContent = message), 100); // trigger change detection
    }
  }

  ngOnInit() {


    this.expandedSidenavChange();

    if (localStorage.getItem("token") && localStorage.getItem("account")) {
      this.platformglobalService.me = JSON.parse(
        localStorage.getItem("account")
      );
    }

    this.items$ = this.sidenavService.items$.pipe(
      map((items: SidenavItem[]) =>
        this.sidenavService.sortRecursive(items, "position")
      )
    );

    this.userSub = this.platformglobalService.user.subscribe((me) => {
      console.log("me", me);
      this.account = me;
      this.account_user_name =
        this.account.first_name + " " + this.account.last_name;
      this.account_user_email = this.account.email;
    });

    this.currentUserService.GetCurrentUser().subscribe(
      (response) => {
        this.Current_User = response;
        this.platformglobalService.setCUserInfo = response;


        const accEmail = this.Current_User.username;
        const accDomain = accEmail.replace(/.*@/, "");
        console.log("Domain Info", accDomain);
        if (accDomain === "continualengine.com") {
          this.isContinualEngine = true;
        } else {
          this.isContinualEngine = false;
        }

        switch (this.Current_User.new_configs.plan_type) {
          case "prep-and-rsp": {
            this.sidenavService.addItems([
              {
                name: "Dashboard",
                viewName: this.LangTextData.menuLabel.menuDashboard,
                routeOrFunction: "/dashboard",
                icon: "dashboard",
                position: 10,
                pathMatchExact: true,
              },
              {
                name: "Upload File",
                viewName: this.LangTextData.menuLabel.menuUploadFile,
                routeOrFunction: "/file-upload",
                icon: "upload_file",
                position: 15,
              },
              {
                name: "Exports",
                viewName: this.LangTextData.menuLabel.menuExport,
                routeOrFunction: "/exports",
                icon: "download_for_offline",
                position: 20,
              },
            ]);
            break;
          }
          case "rsp": {
            this.sidenavService.addItems([
              {
                name: "Dashboard",
                viewName: this.LangTextData.menuLabel.menuDashboard,
                routeOrFunction: "/dashboard",
                icon: "dashboard",
                position: 10,
                pathMatchExact: true,
              },
              {
                name: "Upload File",
                viewName: this.LangTextData.menuLabel.menuUploadFile,
                routeOrFunction: "/file-upload",
                icon: "upload_file",
                position: 15,
              },
            ]);
            break;
          }

          case "prep": {
            this.sidenavService.addItems([
              {
                name: "Dashboard",
                viewName: this.LangTextData.menuLabel.menuDashboard,
                routeOrFunction: "/dashboard",
                icon: "dashboard",
                position: 10,
                pathMatchExact: true,
              },
              {
                name: "Upload File",
                viewName: this.LangTextData.menuLabel.menuUploadFile,
                routeOrFunction: "/file-upload",
                icon: "upload_file",
                position: 15,
              },
              {
                name: "Exports",
                viewName: this.LangTextData.menuLabel.menuExport,
                routeOrFunction: "/exports",
                icon: "download_for_offline",
                position: 20,
              },
            ]);

            break;
          }
        }

        switch (this.Current_User.new_configs.user_access_level_type) {
          case "admin-view": {
            if (this.sidenavService.items.length > 0) {
              this.sidenavService.items.forEach((element, index) => {
                if (element.name === "Upload File") {
                  this.sidenavService.items.splice(index, 1);
                }
                if (element.name === "Exports") {
                  this.sidenavService.items.splice(index, 1);
                }
              });
            }
            break;
          }
        }

        if (this.Current_User.new_configs.is_superadmin === true) {
          this.sidenavService.addItems([
            {
              name: "Reports",
              viewName: this.LangTextData.menuLabel.menuReport,
              routeOrFunction: "/report",
              icon: "analytics",
              position: 25,
            },
          ]);

          if (this.Current_User.new_configs.is_superadmin === true) {
            console.log("I Can Insde");
            if (this.Current_User.new_configs.ceadmin === true) {
              this.sidenavService.addItems([
                {
                  name: "ADMIN TOOL",
                  viewName: this.LangTextData.menuLabel.menuHeaderAdminTool,
                  position: 30,
                  type: "subheading",
                  customClass: "first-subheading",
                },
                {
                  name: "Account Config",
                  viewName: this.LangTextData.menuLabel.menuAccountConfig,
                  routeOrFunction: "/account-config",
                  icon: "manage_accounts",
                  position: 35,
                },
                {
                  name: "Template Config",
                  viewName: this.LangTextData.menuLabel.menuTemplateConfig,
                  routeOrFunction: "/templates",
                  icon: "article",
                  position: 35,
                },
                {
                  name: "External Usage",
                  viewName: this.LangTextData.menuLabel.menuExternalUsage,
                  routeOrFunction: "/external-usage",
                  icon: "data_usage",
                  position: 36,
                },
                {
                  name: "CE ADMIN",
                  viewName: this.LangTextData.menuLabel.menuHeaderCEAdmin,
                  routeOrFunction: "/ce-admin",
                  icon: "manage_accounts",
                  position: 40,
                },

                {
                  name: "Usage Dashboard",
                  viewName: this.LangTextData.menuLabel.menuUsageDashboard,
                  routeOrFunction: "/usage-dashboard",
                  icon: "analytics",
                  position: 35,
                },
                {
                  name: "CE USER NOTIF",
                  viewName:
                    this.LangTextData.menuLabel.menuCEUserNotificationUser,
                  routeOrFunction: "/ce-user-notif",
                  icon: "manage_accounts",
                  position: 40,
                },
                {
                  name: "External Contact",
                  viewName: this.LangTextData.menuLabel.menuExternalContact,
                  routeOrFunction: "/external-contact",
                  icon: "manage_accounts",
                  position: 40,
                },
                // {
                //   name: 'File Uploads Usage',
                //   routeOrFunction: '/file-uploads-count',
                //   icon: 'analytics',
                //   position: 45,
                // },
                // {
                //   name: 'API Usage',
                //   routeOrFunction: '/api-usage',
                //   icon: 'data_usage',
                //   position: 50,
                // },
              ]);
            } else {
              this.sidenavService.addItems([
                {
                  name: "ADMIN TOOL",
                  viewName: this.LangTextData.menuLabel.menuHeaderAdminTool,
                  position: 30,
                  type: "subheading",
                  customClass: "first-subheading",
                },
                {
                  name: "Usage Dashboard",
                  viewName: this.LangTextData.menuLabel.menuUsageDashboard,
                  routeOrFunction: "/usage-dashboard",
                  icon: "analytics",
                  position: 35,
                },
                // {
                //   name: 'File Uploads Usage',
                //   routeOrFunction: '/file-uploads-count',
                //   icon: 'analytics',
                //   position: 45,
                // },
                // {
                //   name: 'API Usage',
                //   routeOrFunction: '/api-usage',
                //   icon: 'data_usage',
                //   position: 50,
                // },
              ]);
            }
          } else {
            this.sidenavService.addItems([
              {
                name: "ADMIN TOOL",
                viewName: this.LangTextData.menuLabel.menuHeaderAdminTool,
                position: 30,
                type: "subheading",
                customClass: "first-subheading",
              },
              {
                name: "Usage Dashboard",
                viewName: this.LangTextData.menuLabel.menuUsageDashboard,
                routeOrFunction: "/usage-dashboard",
                icon: "analytics",
                position: 35,
              },
              // {
              //   name: 'File Uploads Usage',
              //   routeOrFunction: '/file-uploads-count',
              //   icon: 'analytics',
              //   position: 45,
              // },
              // {
              //   name: 'API Usage',
              //   routeOrFunction: '/api-usage',
              //   icon: 'data_usage',
              //   position: 50,
              // },
            ]);
          }
          if (this.Current_User.new_configs.prep_configs.clms) {
            if (this.Current_User.configs.clms === true) {
              this.sidenavService.addItems([
                {
                  name: "CANVAS INTEGRATION",
                  viewName:
                    this.LangTextData.menuLabel.menuHeaderCanvasIntegration,
                  position: 40,
                  type: "subheading",
                  customClass: "first-subheading",
                },
                {
                  name: "Canvas LMS Files",
                  viewName: this.LangTextData.menuLabel.menuCanvasLMSFiles,
                  routeOrFunction: "/canvas-lms-files",
                  icon: "folder",
                  position: 40,
                },
              ]);
            }
          }

          if (
            this.Current_User.new_configs.plan_type === "prep-and-rsp" ||
            this.Current_User.new_configs.plan_type === "rsp"
          ) {
            this.sidenavService.addItems([
              {
                name: "REMEDIATION SERVICES",
                viewName:
                  this.LangTextData.menuLabel.MenuHeaderRemediationServices,
                position: 55,
                type: "subheading",
                customClass: "first-subheading",
              },
              {
                name: "Orders",
                viewName: this.LangTextData.menuLabel.menuOrder,
                routeOrFunction: "/orders",
                icon: "receipt_long",
                position: 60,
              },
            ]);

            switch (this.Current_User.new_configs.user_access_level_type) {
              case "org-admin": {
                if (
                  this.Current_User.new_configs.subscription_configs
                    .payment_mode === "online"
                ) {
                  this.sidenavService.addItems([
                    {
                      name: "Transactions",
                      viewName: this.LangTextData.menuLabel.menuTransactions,
                      routeOrFunction: "/RSP-Dept-Transaction",
                      icon: "paid",
                      position: 65,
                    },
                  ]);
                } else {
                  this.sidenavService.addItems([
                    {
                      name: "Transactions",
                      viewName: this.LangTextData.menuLabel.menuTransactions,
                      routeOrFunction: "/transcations",
                      icon: "paid",
                      position: 65,
                    },
                  ]);
                }
                break;
              }
              case "dept-admin": {
                if (
                  this.Current_User.new_configs.subscription_configs
                    .payment_mode === "online"
                ) {
                  this.sidenavService.addItems([
                    {
                      name: "Transactions",
                      viewName: this.LangTextData.menuLabel.menuTransactions,
                      routeOrFunction: "/RSP-Dept-Transaction",
                      icon: "paid",
                      position: 65,
                    },
                  ]);
                } else {
                  this.sidenavService.addItems([
                    {
                      name: "Transactions",
                      viewName: this.LangTextData.menuLabel.menuTransactions,
                      routeOrFunction: "/transcations",
                      icon: "paid",
                      position: 65,
                    },
                  ]);
                }
                break;
              }
              case "user": {
                break;
              }
              case "no-access": {
                break;
              }

            }
          }

          if (this.Current_User.new_configs.prep_configs.d2l === true) {
            this.sidenavService.addItems([
              {
                name: "D2L INTEGRATION",
                viewName: this.LangTextData.menuLabel.MenuHeaderD2lIntegration,
                position: 100,
                type: "subheading",
                customClass: "first-subheading",
              },
              {
                name: "D2L LMS Files",
                viewName: this.LangTextData.menuLabel.menuD2lLMSFiles,
                routeOrFunction: "/d2l-lms-files",
                icon: "folder",
                position: 105,
              },
            ]);
          }

          if (
            this.isContinualEngine === true &&
            this.Current_User.new_configs.ceadmin === true
          ) {
            this.sidenavService.addItems([
              {
                name: "RSP SERVICE ADMIN",
                viewName:
                  this.LangTextData.menuLabel.MenuHeaderRSPAdministration,
                position: 90,
                type: "subheading",
                customClass: "first-subheading",
              },
              {
                name: "CE Orders",
                viewName: this.LangTextData.menuLabel.menuCEOrders,
                routeOrFunction: "/RSP-CE-Orders",
                icon: "receipt",
                position: 95,
              },
            ]);
          }
        } else {
          if (
            this.Current_User.new_configs.plan_type === "prep-and-rsp" ||
            this.Current_User.new_configs.plan_type === "rsp"
          ) {
            this.sidenavService.addItems([
              {
                name: "RSP SERVICE ADMIN",
                viewName:
                  this.LangTextData.menuLabel.MenuHeaderRemediationServices,
                position: 55,
                type: "subheading",
                customClass: "first-subheading",
              },
              {
                name: "CE Orders",
                viewName: this.LangTextData.menuLabel.menuOrder,
                routeOrFunction: "/orders",
                icon: "receipt_long",
                position: 60,
              },
            ]);

            switch (this.Current_User.new_configs.user_access_level_type) {
              case "org-admin": {
                if (
                  this.Current_User.new_configs.subscription_configs
                    .payment_mode === "online"
                ) {
                  this.sidenavService.addItems([
                    {
                      name: "Transactions",
                      viewName: this.LangTextData.menuLabel.menuTransactions,
                      routeOrFunction: "/RSP-Dept-Transaction",
                      icon: "paid",
                      position: 65,
                    },
                  ]);
                } else {
                  this.sidenavService.addItems([
                    {
                      name: "Transactions",
                      viewName: this.LangTextData.menuLabel.menuTransactions,
                      routeOrFunction: "/transcations",
                      icon: "paid",
                      position: 65,
                    },
                  ]);
                }
                break;
              }
              case "dept-admin": {
                if (
                  this.Current_User.new_configs.subscription_configs
                    .payment_mode === "online"
                ) {
                  this.sidenavService.addItems([
                    {
                      name: "Transactions",
                      viewName: this.LangTextData.menuLabel.menuTransactions,
                      routeOrFunction: "/RSP-Dept-Transaction",
                      icon: "paid",
                      position: 65,
                    },
                  ]);
                } else {
                  this.sidenavService.addItems([
                    {
                      name: "Transactions",
                      viewName: this.LangTextData.menuLabel.menuTransactions,
                      routeOrFunction: "/transcations",
                      icon: "paid",
                      position: 65,
                    },
                  ]);
                }
                break;
              }
              case "user": {
                if (this.sidenavService.items.length > 0) {
                  this.sidenavService.items.forEach((element, index) => {
                    if (element.name === "Users") {
                      this.sidenavService.items.splice(index, 1);
                    }
                  });
                }
                break;
              }
              case "no-access": {
                if (this.sidenavService.items.length > 0) {
                  this.sidenavService.items.forEach((element, index) => {
                    if (element.name === "Users") {
                      this.sidenavService.items.splice(index, 1);
                    }
                  });
                }
                break;
              }
            }
          }
        }

        if (this.Current_User.new_configs.subscription_configs.civic_plus) {
          this.sidenavService.addItems([
            {
              name: "CIVICPLUS INTEGRATION",
              viewName:
                this.LangTextData.menuLabel.menuHeaderCivicPlusIntegration,
              position: 40,
              type: "subheading",
              customClass: "first-subheading",
            },
            {
              name: "CivicPlus Files",
              viewName: this.LangTextData.menuLabel.menuCivicPlusFiles,
              routeOrFunction: "/civic-plus-files",
              icon: "folder",
              position: 40,
            },
          ]);
        }

        if (
          this.Current_User.new_configs.users.enable_manage_accounts === true
        ) {
          this.sidenavService.addItems([
            {
              name: "Users",
              viewName: this.LangTextData.menuLabel.menuUsers,
              routeOrFunction: "/users",
              icon: "person",
              position: 35,
            },
          ]);
        }
      },
      (error) => {
        this.logoutClicked();
      }
    );
    this.items$ = this.sidenavService.items$.pipe(
      map((items: SidenavItem[]) =>
        this.sidenavService.sortRecursive(items, "position")
      )
    );
  }

  expandedSidenavChange() {
    this.sidenavService.expanded$.subscribe((value) => {
      // console.log("📏 expanded$:", value);
      if (this.collapsed) {
        this.expandedSidenav = value;
      } else {
        this.expandedSidenav = true;
      }
    });
  }

  ngOnDestroy(): void {
    // this.cleanupSubscriptions();
  }

  logoutClicked() {
    let sendUserInfo = {
      username: this.account_user_email,
    };
    this.dashboardService.logoutCuncurrentUser(sendUserInfo).subscribe(
      (response) => {
        if (response.msg) {
          localStorage.removeItem("token");
          localStorage.removeItem("account");
          this.sidenavService.items = [];
          this.router.navigate(["/login"]);
          this.snackbar.open("Signed out.", "", {
            duration: 3000,
          });
        }
      },
      (error) => {
        console.log("error", error);
        localStorage.removeItem("token");
        localStorage.removeItem("account");
        this.sidenavService.items = [];
        this.router.navigate(["/login"]);
        this.snackbar.open("Signed out.", "", {
          duration: 3000,
        });
      }
    );
  }

  profile() {
    console.log("welcome to profile");
    this.router.navigate(["/profile"]);
    this.snackbar.open("Welcome to My Profile!", "", {
      duration: 3000,
    });
  }

  goBacktoDahboard() {
    this.router.navigate(["/dashboard"]);
    this.snackbar.open("Welcome to Dashboard!", "", {
      duration: 3000,
    });
  }
  toggleCollapsed() {
    this.collapsed = !this.collapsed;

    if (this.collapsed) {
      this.expandedSidenav = false;
      this.expandedSidenavChange();
    } else {
      this.expandedSidenav = true;
      this.expandedSidenavChange();
    }
    this.sidenavService.toggleCollapsed();
  }

  @HostListener("mouseenter")
  @HostListener("touchenter")
  onMouseEnter() {
    this.sidenavService.setExpanded(true);
  }

  @HostListener("mouseleave")
  @HostListener("touchleave")
  onMouseLeave() {
    this.sidenavService.setExpanded(false);
  }
}
